import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_printInvSO = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_SO}` + `/print_inv_so/${id}`);
};

export const billing_expense_addInv_SO = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.INVOICE_SO}` + `/`, data);
};

export const billing_expense_getdataByIdInv_SO = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_SO}` + `/getbyid/${id}`);
};

export const billing_expense_deleteInv_SO = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.INVOICE_SO}` + `/${id}`);
};
